import React from "react"

import { Box } from "@mui/material"

import { ErrorResponse, Loading, RestResponse, } from "@sinossi/mates-react-library"

import withUseRouter, { UseRouterParams } from "services/router"
import { DashboardServices } from "services/dashboard.services"

import { MatesComponent, MatesComponentState, } from "components/mates-component"
import { PageHeader, RoutesData, } from "components/commons"

import { DashboardResponse } from "models/dashboard"

import { ActionsServices } from "services/actions.services"
import { AccountType, Action, ActionsRequest, SessionResponse, WorkflowStepType, } from "models"
import { PaginatedResponse } from "models/commons/paginated-response"
import { DashboardAdmin } from "components/dashboard/dashboard-admin"
import { DashboardBrand } from "components/dashboard/dashboard-brand"
import { DashboardMicrojobber } from "components/dashboard/dashboard-microjobber"
import { DashboardLandlord } from "components/dashboard/dashboard-landlord"

interface DashboardProps extends UseRouterParams {
	sessionData: SessionResponse
}
interface DashboardState extends MatesComponentState {
	dashboardData: DashboardResponse | null
	actions: PaginatedResponse<Action> | null
	notifications: PaginatedResponse<Action> | null
}
class Home extends React.Component<DashboardProps, DashboardState> {
	private readonly matesComponent: MatesComponent<DashboardProps, DashboardState> = new MatesComponent(this)

	constructor(props: DashboardProps) {
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: true,
			dashboardData: null,
			actions: null,
			notifications: null
		}
	}

	public componentDidMount() {
		this.getDashboard()
	}

	private getDashboard = (): void => {
		DashboardServices.getDashboard(this.updateDashboardValues, this.matesComponent.onException)
	}

	private updateDashboardValues = (response: RestResponse<DashboardResponse, ErrorResponse>): void => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(
			() => ({ dashboardData: response.data, }),
			this.getActions
		)
	}

	private getActions = (): void => {
		if (this.props.sessionData.accountType === "ADMIN") {
			const request: ActionsRequest = {
				pageSize: 50,
				pageId: 0,
				orderType: null,
				orderBy: null,
				executor: null,
				statusList: null,
				type: null,
				executionStartDate: null,
				executionEndDate: null
			}

			ActionsServices.getDashboardActions(request, this.getActionsCallback, this.matesComponent.onException)
			return
		}

		ActionsServices.dashboardBrandActions(this.getActionsCallback, this.matesComponent.onError)

	}

	private getActionsCallback = (response: RestResponse<PaginatedResponse<Action>, ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		let notifications: Action[] = []
		let actions: Action[] = []

		if (response.data) {
			response.data.items.forEach((action) => {
				if (action.actionType === WorkflowStepType.NOTIFICATION) {
					notifications.push(action)
				}
				else {
					actions.push(action)
				}
			})


			this.setState(() => ({
				loading: false,
				actions: {
					items: actions.sort((a, b) => new Date(a.deadline).getTime() - new Date(b.deadline).getTime()),
					pagination: response.data!.pagination
				},
				notifications: {
					items: notifications.sort((a, b) => new Date(a.deadline).getTime() - new Date(b.deadline).getTime()),
					pagination: response.data!.pagination
				}
			}))
		}
	}

	render() {

		let dashboardComponent: React.ElementType = DashboardAdmin

		if (this.props.sessionData.accountType === AccountType.BRAND) {
			dashboardComponent = DashboardBrand
		}

		if (this.props.sessionData.accountType === AccountType.MICROJOB) {
			dashboardComponent = DashboardMicrojobber
		}

		if (this.props.sessionData.accountType === AccountType.LANDLORD) {
			dashboardComponent = DashboardLandlord
		}

		return (
			<Box component="div" sx={{ pt: 2 }}>
				<Loading show={this.state.loading} />
				<PageHeader
					title={RoutesData.DASHBOARD.title}
					path={"Dashboard home"} />

				{(this.state.dashboardData !== null && this.state.actions !== null) &&
					<Box
						component={dashboardComponent}
						dashboardData={this.state.dashboardData}
						actions={this.state.actions}
						notifications={this.state.notifications}
						onException={this.matesComponent.onException}
						sessionData={this.props.sessionData}
						refreshActions={this.getActions}
					/>
				}
			</Box>
		)
	}
}

export default withUseRouter(Home)
